var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVpHouse = function SvgVpHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 125 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 62.5,
    cy: 62.5,
    r: 62.5,
    fill: "#8CB3DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 62.5A62.5 62.5 0 0 1 62.5 125C27.98 125 0 97.016 0 62.5a62.412 62.412 0 0 1 25.662-50.496L62.5 62.71V0C97.016 0 125 27.98 125 62.5Z",
    fill: "#8CB3DC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 62.875,
    cy: 62.875,
    r: 46.875,
    fill: "#1A5CA3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.972 41.394v6.056l5.343 5.203v-11.26h-5.343Z",
    fill: "#8CB3DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.534 40.756v-2.11a.648.648 0 0 0-.647-.646h-6.496a.648.648 0 0 0-.647.647v2.11c0 .355.29.646.647.646h6.496a.654.654 0 0 0 .647-.647Z",
    fill: "#8CB3DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.733 42.5 46.037 58.747v23.86H79.43v-23.86L62.733 42.5Z",
    fill: "#AEDAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M49.993 61.175c0-.572.234-1.116.637-1.51L65.508 45.2l-2.774-2.7-16.697 16.247v23.86h3.956V61.174ZM72.972 41.394v6.056l5.343 5.203v-11.26h-5.343Z",
    fill: "#8CB3DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M76.065 47.862a1.397 1.397 0 0 1-.421-1.003v-5.465h-2.672v6.056l5.343 5.203v-2.597l-2.25-2.194Z",
    fill: "#1C7CE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m83.865 57.762-19.734-19.2a2.016 2.016 0 0 0-2.794 0l-19.735 19.2a2.009 2.009 0 0 0-.037 2.832 2 2 0 0 0 2.831.037l18.066-17.578c.15-.15.394-.15.553 0l18.066 17.569c.796.769 2.062.75 2.83-.038.76-.787.741-2.053-.046-2.822Z",
    fill: "#FFE6A1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.462 43.053a.42.42 0 0 1 .244-.112l1.762-1.707a1.979 1.979 0 0 1 1.903-.497l-2.24-2.175a2.016 2.016 0 0 0-2.794 0l-19.735 19.2a2.009 2.009 0 0 0-.037 2.832 2 2 0 0 0 2.831.037l18.066-17.578Z",
    fill: "#FFD553"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.534 40.756v-2.11a.648.648 0 0 0-.647-.646h-6.496a.648.648 0 0 0-.647.647v2.11c0 .355.29.646.647.646h6.496a.654.654 0 0 0 .647-.647Z",
    fill: "#8CB3DC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M74.21 40.756v-2.11c0-.355.29-.646.646-.646h-2.465a.648.648 0 0 0-.647.647v2.11c0 .355.29.646.647.646h2.465a.654.654 0 0 1-.647-.647Z",
    fill: "#1C7CE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M64.365 64.615v13.528c0 .3.244.544.544.544h10.124c.3 0 .544-.244.544-.544V64.615H64.365Z",
    fill: "#014A99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M70.694 64.709c0-.038 0-.066-.01-.094H69.25c0 .028-.01.066-.01.094v6.263h-1.246v1.453h1.246v6.262h1.454v-6.262h4.875v-1.453h-4.875v-6.263Z",
    fill: "#AEDAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M68.537 78.678h-3.629a.544.544 0 0 1-.543-.544V64.615h3.628v13.528c0 .29.244.535.544.535Z",
    fill: "#1C7CE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M64.365 70.972h3.628v1.453h-3.628v-1.453Z",
    fill: "#BBDAF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.024 61.193H64.9c-.3 0-.543.216-.543.479v2.615h11.203v-2.616c.009-.262-.235-.478-.535-.478Z",
    fill: "#1C7CE5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M68.537 61.193c-.3 0-.544.244-.544.544v2.981-.093h-3.628v-2.879c0-.3.244-.543.544-.543h3.628v-.01Z",
    fill: "#014A99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.103 61.737v20.869H49.9V61.737c0-.3.244-.544.544-.544h10.125c.29 0 .534.244.534.544Z",
    fill: "#E87F56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.072 61.193c-.3 0-.544.244-.544.544v20.869H49.9V61.737c0-.3.244-.544.544-.544h3.628Z",
    fill: "#014A99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.73 72.716a1.022 1.022 0 1 0 0-2.044 1.022 1.022 0 0 0 0 2.044Z",
    fill: "#DFEBFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.133 82.315h-34.8a.694.694 0 0 0-.693.704v2.287c0 .384.309.694.693.694h34.81c.384 0 .703-.31.703-.703v-2.288a.715.715 0 0 0-.713-.694Z",
    fill: "#99EDBA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.055 85.297v-2.288a.7.7 0 0 1 .694-.703h-4.416a.694.694 0 0 0-.693.703v2.288a.7.7 0 0 0 .693.703h4.416a.694.694 0 0 1-.694-.703Z",
    fill: "#57C975"
  })));
};
export default SvgVpHouse;